export const CountryIsoCodeTaxIdMapping: Record<string, string> = {
  //   IND: 'PAN',
  //   GBR: 'UKIMS'
};
